export default function Loading() {
    return (
        <div className="flex justify-center items-center h-screen">
            <div className="loader border-t-transparent border-solid border-white border-4 rounded-full h-16 w-16 animate-spin"></div>
        </div>
    );
}